import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import { IsForProfit, RulesetResult } from '../rules';
import IsFBO from '../rules/IsFBO';

class ApplicantFiledTaxReturnsInThePastRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    if (IsFBO.evaluate(data)) return RulesetResult.HIDDEN;
    if (!IsForProfit.evaluate(data)) return RulesetResult.REQUIRED;
    return RulesetResult.HIDDEN;
  };
}

export default new ApplicantFiledTaxReturnsInThePastRuleset();
